module.exports = __webpack_public_path__ + "static/img/14002008.c9d3c7d4.png";